import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import swal from 'sweetalert2';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent extends ComponentBase implements OnInit {

  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    const url = this.attribute.value ?? '';
    const children = this.attribute.attributes ?? [];

    const messageAttr = children.find(attr => attr.key.toLowerCase() === 'message');
    const message = messageAttr?.value ?? `Redirecionando para o site ${url}.`;

    const queryParamsAttr = children.find(attr => attr.key.toLowerCase() === 'query params');
    const params: Record<string, string> = {};
    (queryParamsAttr?.attributes ?? []).forEach(attr => {
      params[attr.key] = attr.value ?? '';
    });

    swal.fire({
      icon: 'info',
      title: 'Redirecionando...',
      text: message,
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false
    }).then(() => {
      (window as any).__intentionalRedirect = true;
      if (url.startsWith('http')) {
        window.location.href = url;
      } else {
        this.router.navigate([url], { queryParams: params });
      }
    });
  }
}
